import {fromJS} from 'immutable';
import {Store} from 'client/framework';
import radioButtonGroupActions from './RadioButtonGroup.actions';

export default class RadioButtonGroupStore extends Store {
  constructor(name) {
    super(name);
    this.initialData = fromJS({
      selectedItem: null,
      storeName: ''
    });
    this.setInitialData(this.initialData);
    this.handleTargeted(radioButtonGroupActions.RESET_STORE, this._resetStore);
    this.handleTargeted(radioButtonGroupActions.SET_SELECTED_ITEM, this._setSelectedItem);
    this.handleTargeted(radioButtonGroupActions.SET_STORE_NAME, this._setStoreName);
  }

  _resetStore() {
    this.writeData(this.initialData);
  }

  _setSelectedItem(item) {
    this.writeData('selectedItem', item);
  }

  _setStoreName(storeName) {
    this.writeData('storeName', storeName);
  }

  getSelectedItem() {
    return this.readData('selectedItem');
  }

  getStoreName() {
    return this.readData('storeName');
  }
}
